import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Title/Title'
import WebComponent from '../../WebComponent.js'

export default class Landing extends WebComponent {

  get translationFile() {
    return './views/Landing/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.render()
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('page.title')}"
      ></isceco-title>
      <p>${this.i18n.translate('page.text')}</p>
    `
  }

}
customElements.define('eform-frontend-landing', Landing)
